<script lang="ts">
    
    import type { TextContentDto } from "../../global";

    export let content: TextContentDto;

</script>

<p>{content.text}</p>

<style lang="scss">

    p {
        padding-left: 15px;
        padding-right: 15px;
    }

</style>
